/* ============================================================================
FILE: po-about-multiple-pluriel-fr-en-es-20260222.js
MODE: localStorage language (FR/EN/ES) — NO external translation (translate="no")
API:  window.PoAboutMultiplePlurielFR_EN_ES_20260222
ROOT: .po-about[data-po-about][data-po-about-instance]

ROLE:
- Injecte uniquement les slots (texte contrôlé) selon la langue choisie (FR/EN/ES).
- Bloque toute traduction extérieure via translate="no" + notranslate au niveau du root.
- Multi-instances OK. Boutons par instance + synchro globale via localStorage.
============================================================================ */
(function(){
  "use strict";

  var API_NAME = "PoAboutMultiplePlurielFR_EN_ES_20260222";
  var ROOT_SEL = ".po-about[data-po-about][data-po-about-instance]";
  var LS_KEY   = "po_about_lang"; // "fr" | "en" | "es"

  function safeTrim(s){ return (s==null) ? "" : String(s).replace(/^\s+|\s+$/g,""); }
  function qs(root, sel){
    if(!root) return null;
    if(root.querySelector) return root.querySelector(sel);
    return null;
  }
  function qsa(root, sel){
    if(!root) return [];
    if(root.querySelectorAll) return Array.prototype.slice.call(root.querySelectorAll(sel));
    return [];
  }

  function getLang(){
    var v = "";
    try{ v = safeTrim(localStorage.getItem(LS_KEY)); }catch(e){}
    v = (v || "fr").toLowerCase();
    if(v !== "fr" && v !== "en" && v !== "es") v = "fr";
    return v;
  }
  function setLang(lang){
    var v = (lang||"").toLowerCase();
    if(v !== "fr" && v !== "en" && v !== "es") v = "fr";
    try{ localStorage.setItem(LS_KEY, v); }catch(e){}
    try{
      window.dispatchEvent(new CustomEvent("po:locale-changed", { detail:{ lang:v, key:LS_KEY } }));
    }catch(e){}
    renderAll();
  }

  var TEXTS = {
    fr: {
      hero_kicker: "GENÈSE",
      hero_title: "À propos",
      hero_lede: "Le Posœnnoïsme se présente comme une architecture du Multiple-Pluriel : une manière d’habiter la complexité, de la rendre lisible, transmissible et féconde, par la création, la pensée et l’accordage des formes.",
      sections: [
        {
          title: "Origine",
          body: [
            "Le Posœnnoïsme apparaît comme une expérience intérieure du multiple en interaction.",
            "Il se déploie depuis un état de conscience en activité permanente, nourri par une perception simultanée des strates du réel : mémoire, présent, projection, relation, intensité.",
            "Cette émergence se vit avant de se formuler. Elle s’impose comme une architecture intime déjà en mouvement, un agencement dynamique où les niveaux d’expérience dialoguent et se redistribuent.",
            "La structure naît d’images. Axes, rythmes, géométries, articulations composent une ossature qui s’organise progressivement en ensemble opératif. Les figures orientent. Les rythmes modulent. Les axes relient.",
            "La matière provient d’un travail soutenu, d’une étude approfondie des champs philosophiques, scientifiques, symboliques et culturels. Chaque exploration renforce la cohérence d’ensemble. Chaque recherche nourrit l’architecture.",
            "La forme émane de la vision. La substance procède du processus."
          ]
        },
        {
          title: "Principe axial",
          body: [
            "Au centre de cette construction règne une dynamique essentielle :",
            "tout fonctionne avec tout.",
            "Chaque élément agit par interaction. Chaque transformation redistribue les équilibres. Chaque point révèle une interdépendance active.",
            "Pensée, langage, nombre, forme, mémoire, création et conscience participent d’un même champ. Le réel se maintient en se réaccordant à lui-même. Les intensités circulent, les tensions s’ajustent, les différences trouvent leur place dans une cohérence mobile.",
            "Ce principe s’impose comme évidence opérative issue de l’observation directe du fonctionnement du réel et de la pensée."
          ],
          callout_lines: [
            "Le Multiple-Pluriel demeure un champ de circulation :",
            "la cohérence y naît du mouvement, et la forme y demeure vivante."
          ]
        },
        {
          title: "Démarche",
          body: [
            "Sa démarche consiste à relier, structurer, redistribuer.",
            "Relier les domaines. Structurer les interactions. Redistribuer les tensions et les excédents en configurations cohérentes.",
            "Son intention profonde vise à préserver la cohérence du multiple, à faire de la complexité un champ opératif, à transformer l’expérience vécue en architecture transmissible.",
            "Chaque concept possède une fréquence, une signature vibratoire. Le système instaure une lecture fréquentielle du réel où langage, nombre, forme et conscience interagissent en permanence. La pensée acquiert une dimension opérative : elle module, elle ajuste, elle oriente.",
            "Le Posœnnoïsme se propose comme système régénérateur : un espace où la complexité nourrit la cohérence et où la création devient un acte de liage et de transmutation vibratoire. La structure accueille l’intensité, l’ordonne, la redistribue, la rend fertile.",
            "La dimension transculturelle et transhistorique traverse cette démarche : les traditions, les sciences, les arts, les cosmologies, les mémoires situées entrent en correspondance, sans effacer leurs singularités."
          ]
        },
        {
          title: "Création",
          body: [
            "La création occupe une place centrale dans cette dynamique. Elle agit comme champ d’expérimentation et de vérification.",
            "Chaque œuvre met à l’épreuve l’architecture interne. Elle révèle la solidité des articulations, la pertinence des correspondances, la capacité du système à intégrer les variations.",
            "L’acte créatif densifie le modèle et lui donne extension. Il rend visible la circulation des fréquences et l’ajustement des formes.",
            "Ainsi, l’œuvre devient un lieu de connaissance : un laboratoire sensible où la pensée se prouve en forme, et où la forme reconfigure la pensée."
          ]
        },
        {
          title: "Ouverture",
          body: [
            "Le Posœnnoïsme entretient un dialogue vivant avec d’autres champs de connaissance.",
            "Il explore les correspondances entre disciplines, favorise les convergences et met en relation les langages.",
            "Chaque domaine conserve sa singularité tout en participant à une cohérence élargie. Les savoirs entrent en interaction. Les perspectives se croisent. Les structures se répondent.",
            "Ainsi se déploie un système ouvert, vivant, régénérateur : une expérience intérieure devenue architecture consciente par le travail et la vision, puis offerte à la création, à la recherche et à l’expansion continue."
          ]
        }
      ],
      intentions_title: "Intentions",
      intentions: [
        "Offrir un cadre conceptuel rigoureux pour penser le temps vécu",
        "Proposer des pratiques d’incarnation accessibles à tous",
        "Accueillir les chercheurs souhaitant approfondir la modélisation",
        "Maintenir une esthétique cohérente avec la philosophie elle-même",
        "Élargir l’horizon : ouvrir des passages vers d’autres cultures, d’autres époques, d’autres régimes de connaissance"
      ],
      footer_quote: "Ici, le monde se maintient en se réaccordant à lui-même — et la création devient l’art de tenir, relier, redistribuer."
    },

    en: {
      hero_kicker: "GENESIS",
      hero_title: "About",
      hero_lede: "Posœnnoïsm presents itself as an architecture of the Multiple-Plural: a way of inhabiting complexity and making it readable, transmissible, and fertile—through creation, thought, and the tuning of forms.",
      sections: [
        {
          title: "Origin",
          body: [
            "Posœnnoïsm appears as an inner experience of interacting multiplicity.",
            "It unfolds from a state of constantly active consciousness, nourished by a simultaneous perception of reality’s layers: memory, present, projection, relation, intensity.",
            "This emergence is lived before it is formulated. It imposes itself as an intimate architecture already in motion—a dynamic arrangement where levels of experience converse and redistribute.",
            "Its structure arises from images. Axes, rhythms, geometries, articulations compose a frame that gradually organizes itself into an operative whole. Figures orient. Rhythms modulate. Axes connect.",
            "Its material comes from sustained work and deep study across philosophical, scientific, symbolic, and cultural fields. Each exploration strengthens overall coherence. Each research effort nourishes the architecture.",
            "Form emerges from vision. Substance proceeds from process."
          ]
        },
        {
          title: "Axial principle",
          body: [
            "At the center of this construction reigns an essential dynamic:",
            "everything works with everything.",
            "Each element acts through interaction. Each transformation redistributes balances. Each point reveals an active interdependence.",
            "Thought, language, number, form, memory, creation, and consciousness participate in a single field. Reality sustains itself by re-tuning itself. Intensities circulate, tensions adjust, differences find their place within a mobile coherence.",
            "This principle stands as an operative evidence drawn from direct observation of how reality and thought function."
          ],
          callout_lines: [
            "The Multiple-Plural remains a field of circulation:",
            "coherence is born from movement, and form stays alive."
          ]
        },
        {
          title: "Approach",
          body: [
            "Its approach is to connect, structure, redistribute.",
            "Connect domains. Structure interactions. Redistribute tensions and excess into coherent configurations.",
            "Its deep intention is to preserve the coherence of multiplicity, to make complexity an operative field, and to transform lived experience into a transmissible architecture.",
            "Each concept carries a frequency—a vibratory signature. The system installs a frequency-based reading of reality where language, number, form, and consciousness interact continuously. Thought becomes operative: it modulates, adjusts, orients.",
            "Posœnnoïsm proposes itself as a regenerative system: a space where complexity feeds coherence, and where creation becomes an act of binding and vibratory transmutation. Structure welcomes intensity, orders it, redistributes it, and renders it fertile.",
            "A transcultural and transhistorical dimension runs through this approach: traditions, sciences, arts, cosmologies, and situated memories enter into correspondence without erasing their singularities."
          ]
        },
        {
          title: "Creation",
          body: [
            "Creation occupies a central place in this dynamic. It acts as a field of experimentation and verification.",
            "Each work tests the internal architecture. It reveals the strength of articulations, the relevance of correspondences, the system’s capacity to integrate variation.",
            "The creative act densifies the model and extends it. It makes visible the circulation of frequencies and the adjustment of forms.",
            "Thus the work becomes a site of knowledge: a sensitive laboratory where thought proves itself as form, and form reconfigures thought."
          ]
        },
        {
          title: "Openness",
          body: [
            "Posœnnoïsm maintains a living dialogue with other fields of knowledge.",
            "It explores correspondences between disciplines, fosters convergences, and connects languages.",
            "Each domain keeps its singularity while participating in an expanded coherence. Knowledges interact. Perspectives cross. Structures answer one another.",
            "Thus unfolds an open, living, regenerative system: an inner experience turned into conscious architecture through work and vision, then offered to creation, research, and continuous expansion."
          ]
        }
      ],
      intentions_title: "Intentions",
      intentions: [
        "Offer a rigorous conceptual frame for thinking lived time",
        "Propose embodied practices accessible to all",
        "Welcome researchers seeking to deepen the modeling",
        "Maintain an aesthetic coherent with the philosophy itself",
        "Expand the horizon: open passages toward other cultures, other eras, other regimes of knowledge"
      ],
      footer_quote: "Here, the world sustains itself by re-tuning itself—and creation becomes the art of holding, connecting, redistributing."
    },

    es: {
      hero_kicker: "GÉNESIS",
      hero_title: "Acerca de",
      hero_lede: "El Posœnnoísmo se presenta como una arquitectura de lo Múltiple-Plural: un modo de habitar la complejidad y volverla legible, transmisible y fértil—por la creación, el pensamiento y el afinamiento de las formas.",
      sections: [
        {
          title: "Origen",
          body: [
            "El Posœnnoísmo aparece como una experiencia interior de lo múltiple en interacción.",
            "Se despliega desde un estado de conciencia en actividad permanente, alimentado por una percepción simultánea de las capas de lo real: memoria, presente, proyección, relación, intensidad.",
            "Esta emergencia se vive antes de formularse. Se impone como una arquitectura íntima ya en movimiento: un ensamblaje dinámico donde los niveles de experiencia dialogan y se redistribuyen.",
            "Su estructura nace de imágenes. Ejes, ritmos, geometrías, articulaciones componen un armazón que se organiza progresivamente en un conjunto operativo. Las figuras orientan. Los ritmos modulan. Los ejes enlazan.",
            "Su materia proviene de un trabajo sostenido, de un estudio profundo de campos filosóficos, científicos, simbólicos y culturales. Cada exploración refuerza la coherencia de conjunto. Cada investigación nutre la arquitectura.",
            "La forma emana de la visión. La sustancia procede del proceso."
          ]
        },
        {
          title: "Principio axial",
          body: [
            "En el centro de esta construcción reina una dinámica esencial:",
            "todo funciona con todo.",
            "Cada elemento actúa por interacción. Cada transformación redistribuye los equilibrios. Cada punto revela una interdependencia activa.",
            "Pensamiento, lenguaje, número, forma, memoria, creación y conciencia participan de un mismo campo. Lo real se mantiene afinándose de nuevo a sí mismo. Las intensidades circulan, las tensiones se ajustan, las diferencias hallan su lugar en una coherencia móvil.",
            "Este principio se impone como evidencia operativa nacida de la observación directa del funcionamiento de lo real y del pensamiento."
          ],
          callout_lines: [
            "Lo Múltiple-Plural permanece como un campo de circulación:",
            "la coherencia nace del movimiento, y la forma permanece viva."
          ]
        },
        {
          title: "Enfoque",
          body: [
            "Su enfoque consiste en vincular, estructurar, redistribuir.",
            "Vincular dominios. Estructurar interacciones. Redistribuir tensiones y excedentes en configuraciones coherentes.",
            "Su intención profunda busca preservar la coherencia de lo múltiple, hacer de la complejidad un campo operativo y transformar la experiencia vivida en una arquitectura transmisible.",
            "Cada concepto posee una frecuencia, una firma vibratoria. El sistema instaura una lectura frecuencial de lo real donde lenguaje, número, forma y conciencia interactúan sin cesar. El pensamiento adquiere una dimensión operativa: modula, ajusta, orienta.",
            "El Posœnnoísmo se propone como sistema regenerador: un espacio donde la complejidad alimenta la coherencia y donde la creación se vuelve un acto de enlace y transmutación vibratoria. La estructura acoge la intensidad, la ordena, la redistribuye y la vuelve fértil.",
            "Una dimensión transcultural y transhistórica atraviesa este enfoque: tradiciones, ciencias, artes, cosmologías y memorias situadas entran en correspondencia sin borrar sus singularidades."
          ]
        },
        {
          title: "Creación",
          body: [
            "La creación ocupa un lugar central en esta dinámica. Actúa como campo de experimentación y verificación.",
            "Cada obra pone a prueba la arquitectura interna. Revela la solidez de las articulaciones, la pertinencia de las correspondencias, la capacidad del sistema para integrar variaciones.",
            "El acto creativo densifica el modelo y le da extensión. Hace visible la circulación de las frecuencias y el ajuste de las formas.",
            "Así, la obra se vuelve un lugar de conocimiento: un laboratorio sensible donde el pensamiento se prueba en forma, y la forma reconfigura el pensamiento."
          ]
        },
        {
          title: "Apertura",
          body: [
            "El Posœnnoísmo mantiene un diálogo vivo con otros campos de conocimiento.",
            "Explora correspondencias entre disciplinas, favorece convergencias y pone en relación los lenguajes.",
            "Cada dominio conserva su singularidad y participa de una coherencia ampliada. Los saberes interactúan. Las perspectivas se cruzan. Las estructuras se responden.",
            "Así se despliega un sistema abierto, vivo y regenerador: una experiencia interior convertida en arquitectura consciente por el trabajo y la visión, y ofrecida a la creación, la investigación y la expansión continua."
          ]
        }
      ],
      intentions_title: "Intenciones",
      intentions: [
        "Ofrecer un marco conceptual riguroso para pensar el tiempo vivido",
        "Proponer prácticas encarnadas accesibles a todos",
        "Acoger a quienes desean profundizar la modelización",
        "Mantener una estética coherente con la filosofía misma",
        "Ampliar el horizonte: abrir pasajes hacia otras culturas, otras épocas, otros regímenes de conocimiento"
      ],
      footer_quote: "Aquí, el mundo se sostiene volviéndose a afinar a sí mismo—y la creación se vuelve el arte de sostener, vincular, redistribuir."
    }
  };

  function setText(el, text){
    if(!el) return;
    el.setAttribute("translate","no");
    el.className = (el.className ? el.className + " " : "") + "notranslate";
    el.textContent = (text == null) ? "" : String(text);
  }

  function clear(el){
    if(!el) return;
    while(el.firstChild) el.removeChild(el.firstChild);
  }

  function appendP(container, txt){
    var p = document.createElement("p");
    p.setAttribute("translate","no");
    p.className = "po-about__p notranslate";
    p.textContent = txt;
    container.appendChild(p);
  }

  function appendCallout(container, lines){
    var box = document.createElement("div");
    box.className = "po-about__callout notranslate";
    box.setAttribute("translate","no");
    for(var i=0;i<lines.length;i++){
      var l = document.createElement("div");
      l.className = "po-about__callout-line";
      l.textContent = lines[i];
      box.appendChild(l);
    }
    container.appendChild(box);
  }

  function appendIntentions(container, title, items){
    var h = document.createElement("h3");
    h.className = "po-about__h3 notranslate";
    h.setAttribute("translate","no");
    h.textContent = title;
    container.appendChild(h);

    var ul = document.createElement("ul");
    ul.className = "po-about__list notranslate";
    ul.setAttribute("translate","no");
    for(var i=0;i<items.length;i++){
      var li = document.createElement("li");
      li.textContent = items[i];
      ul.appendChild(li);
    }
    container.appendChild(ul);
  }

  function renderOne(root){
    var lang = getLang();
    var t = TEXTS[lang] || TEXTS.fr;

    // root-level translation lock
    root.setAttribute("translate","no");
    root.className = (root.className ? root.className + " " : "") + "notranslate";

    // buttons state
    var btns = qsa(root, "[data-po-lang-btn]");
    for(var i=0;i<btns.length;i++){
      var b = btns[i];
      var v = (b.getAttribute("data-po-lang-btn")||"").toLowerCase();
      var on = (v === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if(on){
        if(b.className.indexOf("is-active")<0) b.className += " is-active";
      }else{
        b.className = b.className.replace(/\bis-active\b/g,"").replace(/\s{2,}/g," ").replace(/^\s+|\s+$/g,"");
      }
    }

    setText(qs(root, '[data-po-slot="hero_kicker"]'), t.hero_kicker);
    setText(qs(root, '[data-po-slot="hero_title"]'),  t.hero_title);
    setText(qs(root, '[data-po-slot="hero_lede"]'),   t.hero_lede);

    // sections
    var secHost = qs(root, '[data-po-slot="sections"]');
    if(secHost){
      clear(secHost);
      for(var s=0;s<t.sections.length;s++){
        var sec = t.sections[s];

        var block = document.createElement("section");
        block.className = "po-about__sec notranslate";
        block.setAttribute("translate","no");

        var h2 = document.createElement("h2");
        h2.className = "po-about__h2 notranslate";
        h2.setAttribute("translate","no");
        h2.textContent = sec.title;

        var rule = document.createElement("div");
        rule.className = "po-about__rule";
        rule.setAttribute("aria-hidden","true");

        block.appendChild(h2);
        block.appendChild(rule);

        var bodyWrap = document.createElement("div");
        bodyWrap.className = "po-about__body";

        for(var p=0;p<sec.body.length;p++){
          var txt = sec.body[p];
          // “tout fonctionne avec tout.” doit ressortir comme ligne axiale
          if(safeTrim(txt).toLowerCase() === "tout fonctionne avec tout."){
            var ax = document.createElement("div");
            ax.className = "po-about__axiom notranslate";
            ax.setAttribute("translate","no");
            ax.textContent = txt;
            bodyWrap.appendChild(ax);
          }else{
            appendP(bodyWrap, txt);
          }
        }

        if(sec.callout_lines && sec.callout_lines.length){
          appendCallout(bodyWrap, sec.callout_lines);
        }

        block.appendChild(bodyWrap);
        secHost.appendChild(block);
      }

      // Intentions (bloc style image)
      appendIntentions(secHost, t.intentions_title, t.intentions);
    }

    setText(qs(root, '[data-po-slot="footer_quote"]'), t.footer_quote);
  }

  function renderAll(){
    var roots = qsa(document, ROOT_SEL);
    for(var i=0;i<roots.length;i++) renderOne(roots[i]);
  }

  function bindOne(root){
    if(root.__po_bound) return;
    root.__po_bound = true;

    var btns = qsa(root, "[data-po-lang-btn]");
    for(var i=0;i<btns.length;i++){
      (function(b){
        b.addEventListener("click", function(){
          var v = (b.getAttribute("data-po-lang-btn")||"fr").toLowerCase();
          setLang(v);
        });
      })(btns[i]);
    }
  }

  function init(){
    var roots = qsa(document, ROOT_SEL);
    for(var i=0;i<roots.length;i++) bindOne(roots[i]);
    renderAll();
  }

  // public API
  window[API_NAME] = {
    init: init,
    render: renderAll,
    getLang: getLang,
    setLang: setLang,
    texts: TEXTS
  };

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }
})();